module.exports = __webpack_public_path__ + "img/evidenza_neg.2251eddf.svg";